import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle2, Download, ArrowLeft } from 'lucide-react';
import { mockData } from '../utils/mockData';
import { useNavigate } from 'react-router-dom';
import '../styles/ThankYou.css';

const ThankYou = () => {
  const navigate = useNavigate();

  const handleDownloadPDF = () => {
    window.open(mockData.pdfUrl, '_blank');
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="thank-you-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo" onClick={handleBackToHome} style={{ cursor: 'pointer' }}>
              <img src={mockData.logoUrl} alt="XMC Algo" className="logo-image" />
              <span className="logo-text">XMC Algo</span>
            </div>
          </div>
        </div>
      </header>

      {/* Thank You Content */}
      <section className="thank-you-section">
        <div className="container">
          <div className="thank-you-content">
            <div className="success-icon-wrapper">
              <CheckCircle2 size={80} className="success-icon" />
            </div>
            
            <h1 className="thank-you-title">Payment Successful! 🎉</h1>
            <p className="thank-you-subtitle">
              Welcome to XMC Algo! Your trading journey starts now.
            </p>

            <Card className="download-card">
              <CardHeader>
                <CardTitle>Get Started with XMC Algo</CardTitle>
                <CardDescription>
                  Download your quick start guide to set up the indicator and start trading with confidence.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="download-section">
                  <div className="pdf-icon">
                    <Download size={32} />
                  </div>
                  <div className="pdf-details">
                    <h3 className="pdf-title">XMC Algo Quick Start Guide</h3>
                    <p className="pdf-description">
                      Step-by-step instructions to install and use your indicator. 
                      Includes a link to submit your TradingView username for access.
                    </p>
                  </div>
                </div>
                <Button 
                  onClick={handleDownloadPDF} 
                  size="lg" 
                  className="download-button"
                >
                  <Download size={20} />
                  Download Quick Start Guide
                </Button>
              </CardContent>
            </Card>

            <div className="next-steps">
              <h2 className="next-steps-title">What's Next?</h2>
              <div className="steps-grid">
                <div className="step-item">
                  <div className="step-number">1</div>
                  <h3>Fill Out the Access Form</h3>
                  <p>
                    <a 
                      href="https://docs.google.com/forms/d/e/1FAIpQLScNwOZVY5jVGFv4NZMEFGu52AndyeSJCTWxXl7HkCPI_MhdhA/viewform?usp=preview" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="access-form-link"
                    >
                      Submit your TradingView username here
                    </a> so we can grant you indicator access
                  </p>
                </div>
                <div className="step-item">
                  <div className="step-number">2</div>
                  <h3>Download the Guide</h3>
                  <p>Get your quick start PDF with setup instructions</p>
                </div>
                <div className="step-item">
                  <div className="step-number">3</div>
                  <h3>Get Access</h3>
                  <p>We'll grant you indicator access within 24 hours</p>
                </div>
              </div>
            </div>

            <div className="support-section">
              <p className="support-text">
                Need help? Check your email for order confirmation and support contact information.
              </p>
              <Button 
                onClick={handleBackToHome} 
                variant="outline" 
                className="back-button"
              >
                <ArrowLeft size={18} />
                Back to Homepage
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <img src={mockData.logoUrl} alt="XMC Algo" className="footer-logo-image" />
              <span className="footer-logo-text">XMC Algo</span>
            </div>
            <p className="footer-text">
              © 2024 XMC Algo. Premium trading indicators for serious traders.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ThankYou;
